export default function cookieBot() {
    const containers = document.querySelectorAll('.js-cookiebot-container');

    containers.forEach((container) => {
        const adBlockContainer = container.querySelector('.js-cookiebot-adblocked');
        const optoutContainer = container.querySelector('.js-cookiebot-optout');
        const optinContainer = container.querySelector('.js-cookiebot-optin');
        if (typeof Cookiebot === 'undefined' || typeof Cookiebot.renew !== 'function') {
            adBlockContainer.classList.remove('hidden');
            optoutContainer.classList.add('hidden');
            optinContainer.classList.add('hidden');
        }
    });
}
